import { createContext, useContext } from "react";
import type * as T from "@src/types";

interface RunDetailContextValue {
  run: T.ApiRun | null;
  type: "backtest" | "execution";
  updateRun: (run: T.ApiRun) => void;
}

const RunDetailContext = createContext<RunDetailContextValue | null>(null);

export const useRunDetail = (): RunDetailContextValue => {
  const ctx = useContext(RunDetailContext);
  if (!ctx) {
    throw new Error("useRunDetail must be used within a RunDetailProvider");
  }
  return ctx;
};

export const RunDetailProvider = RunDetailContext.Provider;
